import { render, staticRenderFns } from "./sidebar-external-message.vue?vue&type=template&id=263fd5f1&scoped=true&"
import script from "./sidebar-external-message.vue?vue&type=script&lang=js&"
export * from "./sidebar-external-message.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-external-message.vue?vue&type=style&index=0&id=263fd5f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263fd5f1",
  null
  
)

export default component.exports